<template>
  <div
    v-if="compositeIframeUrl || isEditing"
    ref="el"
    class="container mb-30 paragraph--margin"
  >
    <div v-if="shouldRender && compositeIframeUrl">
      <iframe
        v-if="shouldResize"
        ref="iframe"
        title="iframe"
        :src="compositeIframeUrl"
        class="w-full"
        :class="{ 'pointer-events-none': isEditing }"
        allowfullscreen
        @load="onLoad"
      />
      <iframe
        v-else
        title="iframe"
        :src="compositeIframeUrl"
        class="w-full"
        :class="{ 'pointer-events-none': isEditing }"
        :style="{
          height: `${height}px`,
        }"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
// @TODO: Needs a title field on the paragraph to provide a sane title for
// accessibility.
import type { ParagraphIframeFragment } from '#graphql-operations'

const { isEditing } = defineBlokkli({
  bundle: 'iframe',
  globalOptions: ['bkVisibleLanguages'],
  chunkName: 'rare',
})

const props = defineProps<{
  iframeDomain?: ParagraphIframeFragment['iframeDomain']
  iframePath?: ParagraphIframeFragment['iframePath']
  height?: ParagraphIframeFragment['height']
}>()

const el = ref<HTMLDivElement | null>(null)
const iframe = ref<HTMLIFrameElement | null>(null)
const shouldRender = useRenderWhenVisible(el)

const shouldResize = computed(() => !props.height)

const compositeIframeUrl = computed(() => {
  if (props.iframeDomain?.name && props.iframePath) {
    return props.iframeDomain?.name + props.iframePath
  }
  return ''
})

async function onLoad() {
  if (!iframe.value) {
    return
  }

  // Dynamically import module because it is quite large.
  const iframeResize = await import('iframe-resizer')
  iframeResize.iframeResizer({}, iframe.value)
}

/*
  Use the following script to pass the height to this component from the iFrame:
  https://raw.githubusercontent.com/davidjbradshaw/iframe-resizer/v4.3.9/js/iframeResizer.contentWindow.min.js
*/

defineOptions({
  name: 'ParagraphIframe',
})
</script>
